var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"mappr"}},[_vm._t("default"),_c('div',{style:(_vm.mapStyle),attrs:{"id":_vm.mapId}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }